import React from 'react';
import PropTypes from 'prop-types';
import Background from 'components/common/background';
import { Card, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AuthSplitLayout = ({ children, bgProps }) => {
  const orgName = process.env.REACT_APP_ORGANIZATION_NAME;

  return (
    <Container
      id="auth-layout"
      fluid
      className="p-0"
      style={{ overflow: 'hidden' }}
    >
      <Row className="min-vh-100 m-0">
        {bgProps && (
          <Background
            {...bgProps}
            style={{
              position: 'absolute',
              inset: 0,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              zIndex: 0
            }}
          />
        )}

        <Col lg={6} className="d-none d-lg-block" />

        <Col
          id="auth-form-wrapper"
          sm={12}
          md={6}
          className="px-sm-0 align-self-center py-5"
          style={{ zIndex: 1 }}
        >
          <Row className="g-0 justify-content-center">
            <Col lg={9} xl={8} className="col-xxl-6">
              <Card>
                <Card.Header className="bg-shape bg-circle-shape text-center p-2">
                  <Link
                    className="text-white font-sans-serif fw-bolder fs-5 z-1 position-relative"
                    to="/"
                  >
                    {orgName}
                  </Link>
                </Card.Header>
                <Card.Body className="p-4">{children}</Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

AuthSplitLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bgProps: PropTypes.shape(Background.propTypes).isRequired
};

export default AuthSplitLayout;
